import { __decorate } from "tslib";
import { Vue, Component, Prop } from 'vue-property-decorator';
import EcommerceProduct from '@/plugins/graphql/queries/v2/ecommerce/product.gql';
import { EcommerceProductFullModel } from '@/helpers/entities/models/EcommerceProductFullModel';
let ProductDetailsMixin = class ProductDetailsMixin extends Vue {
    constructor() {
        super(...arguments);
        this.product = null;
    }
    get queryOnFlight() {
        return this.$apollo.queries.product.loading;
    }
};
__decorate([
    Prop({ type: String, required: true })
], ProductDetailsMixin.prototype, "uuid", void 0);
ProductDetailsMixin = __decorate([
    Component({
        components: {},
        apollo: {
            product: {
                query: EcommerceProduct,
                fetchPolicy: 'cache-and-network',
                variables() {
                    return {
                        productUuid: this.uuid,
                    };
                },
                update(data) {
                    return new EcommerceProductFullModel(data.fetchEcommerceProduct);
                },
                skip() {
                    return !this.uuid;
                },
            },
        },
    })
], ProductDetailsMixin);
export default ProductDetailsMixin;
